import { service } from '@ember/service';
import Route from '@ember/routing/route';
import {
  loadSelectedSchool,
  rollbackUnsavedCourses,
  saveCoursesDate,
} from 'tio-common/utils/tuition-assistance/application-new-route';
import { getSingleValueForTasField } from 'tio-common/utils/tuition-assistance/fields';
import { findRecord } from '@warp-drive/utilities/json-api';
import { saveRecord } from 'tio-data/requests/save-record';
import type { IntlService } from 'ember-intl';
import type RouterService from '@ember/routing/router';
import type { Store } from '@warp-drive/core';
import type { TasApplicationExtension as TasApplicationModel } from 'tio-data/data/resources/tas-application.ext';

export default class AuthenticatedTasApplicationsTypeTwoNewRoute extends Route {
  @service declare store: Store;
  @service declare router: RouterService;
  @service declare intl: IntlService;

  deactivate() {
    rollbackUnsavedCourses(this.store);
  }

  includes = [
    'tas-courses',
    'tas-courses.tas-assets.attachments',
    'tas-program-instance.dependent',
    'tas-program-instance.tas-program-template.tas-groups',
    'tas-program-instance.tas-program-template.conditions.public-assets',
    'tas-program-instance.tas-program-template.tas-field-options',
    'tas-program-instance.employee.person',
    'tas-program-instance.employee.company',
    'tas-program-instance.employee.tas-participant',
    'tas-program-instance.employee.pcs-card-holders',
    'tas-assets.attachments',
    'tas-assistances',
    'tags',
  ];

  queryParams = {
    date: {
      refreshModel: false,
    },
  };

  async model({ tas_application_id, date = '' }: { tas_application_id: string; date?: string }) {
    const { content } = (await this.store.request(
      findRecord<TasApplicationModel>('tas-application', tas_application_id, {
        include: this.includes.join(','),
        reload: true,
      })
    )) as { content: { data: TasApplicationModel } };
    const application = content.data;
    const programInstance = application.tasProgramInstance;

    if (date) {
      const lockStatus: string = getSingleValueForTasField(
        'LOCK_EMPLOYEE_STATUS_BASED_ON',
        programInstance.tasProgramTemplate.fields
      );
      if (saveCoursesDate(date, application, lockStatus)) {
        try {
          await saveRecord(this.store, application);
        } catch (error) {
          console.error('Failed to save application, instance, or course:', error);
          application.rollbackAttributes();
        }
      }
    }

    const selectedSchool = await loadSelectedSchool(programInstance, this.store);

    return {
      application,
      programInstance,
      selectedSchool,
    };
  }
}
